module.exports = "https://static.wmbcdn.com/uniweb/images/7bf360207a9cabd9c93d874c65fc8037.svg";